import { bl_fi_fixed_asset_depreciation_schedule_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterDepreciationScheduleModel extends BaseContainerModel {
  bl_fi_fixed_asset_depreciation_schedule: bl_fi_fixed_asset_depreciation_schedule_RowClass = new bl_fi_fixed_asset_depreciation_schedule_RowClass();
}

export class AssetRegisterDepreciationScheduleQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
